import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Typography } from '@mui/material';
import Breadcrumb from 'src/components/Breadcrumb';
import useStyles from './styles';

const CapitalBalanceSummaryToolbar = ({
  className,
  titleKey,
  ...rest
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Breadcrumb />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography style={{ fontWeight: '400' }} color="primary" variant="h1">
          {t(titleKey)}
        </Typography>
      </div>
    </div>
  );
};

CapitalBalanceSummaryToolbar.propTypes = {
  className: PropTypes.string,
  titleKey: PropTypes.string.isRequired
};

export default CapitalBalanceSummaryToolbar;
